import type { PushlySdk } from '../types/pushly-sdk'
import { injectExternalScript } from '../hooks/use-external-script'
import aqe from '@pushly/aqe'

export const injectPushlySdk = (domainKey: string) => {
    window.PlatformNotifications = {
        supported: true,
    }

    window.PushlySDK = window.PushlySDK || []
    window.pushly = function () {
        window.PushlySDK!.push(arguments)
    }

    injectExternalScript({
        src: `${aqe.defaults.publicCdnDomain}/pushly-sdk.min.js?domain_key=${domainKey}`,
        async: true,
    })

    window.pushly('on_web_push_unsupported', () => {
        window.PlatformNotifications!.supported = false
    })

    window.pushly('load', { domainKey })
}

export const getPushlySdk = (): PushlySdk | undefined => {
    return Array.isArray(window.PushlySDK) ? undefined : window.PushlySDK
}
